import { Button, Grid, Typography } from '@mui/material';
import React from 'react';
import Paper from '@mui/material/Paper';
import BookingModal from '../BookingModal/BookingModal';

const Booking = ({booking,date,setBookingSuccess}) => {
    const {name,time,space}=booking;
    const [openBooking, setBookingOpen] = React.useState(false);
    const handleBookingOpen = () => setBookingOpen(true);
    const handleBookingClose = () => setBookingOpen(false);
    return (
        
           
            <>
            <Grid item xs={12} sm={6} md={4}>
           <Paper elevation={3} sx={{py:5}}>
               <Typography sx={{ color: 'info.main',fontWeight:600 }} variant="h5">
                   {name}
               </Typography>
               <Typography variant="h6">
                   {time}
               </Typography>
               <Typography variant="caption">
                   {space} SPACES AVAILABLE
               </Typography>
               <br />
               <Button onClick={handleBookingOpen} variant="contained">BOOK APPOINTMENT</Button>
           </Paper>
        </Grid>
        <BookingModal
        handleBookingClose={handleBookingClose}
        openBooking={openBooking}
        booking={booking}
        date={date}
        setBookingSuccess={setBookingSuccess}
        >

        </BookingModal>
        </>
        
    );
};

export default Booking;